import { tw } from "@/utils";

export const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={tw("bg-grey-200 animate-pulse rounded-md py-4", className)}
      {...props}
    />
  );
};
